import React, { useEffect, useState } from "react";
import { CalendarStar } from "@phosphor-icons/react";

// Fixed targets (Eastern Time; both dates fall in EDT, UTC-4).
const EVENTS = [
  { id: "anniversary", label: "BSVAC 39th Anniversary", target: "2027-07-17T09:00:00-04:00", when: "July 17, 2027 · 9:00 AM ET" },
  { id: "laborious-day", label: "Laborious Day", target: "2027-09-06T10:00:00-04:00", when: "September 6, 2027 · 10:00 AM ET" },
];

const etDay = (d) => new Intl.DateTimeFormat("en-CA", { timeZone: "America/New_York" }).format(d);

function Unit({ value, label, testid }) {
  return (
    <div className="flex flex-col items-center min-w-[3.25rem]">
      <span className="mono text-3xl sm:text-4xl font-bold text-white tabular-nums leading-none" data-testid={testid}>{String(value).padStart(2, "0")}</span>
      <span className="text-[10px] uppercase tracking-widest text-slate-400 mt-1.5">{label}</span>
    </div>
  );
}

function Countdown({ ev, now }) {
  const target = new Date(ev.target);
  const diff = target - now;
  const isToday = diff <= 0 && etDay(now) === etDay(target);
  const s = Math.max(0, Math.floor(diff / 1000));
  return (
    <div className="relative overflow-hidden rounded-sm bg-slate-900 border border-slate-800 p-5" data-testid={`countdown-${ev.id}`}>
      <div className="absolute -right-6 -top-6 w-28 h-28 rounded-full bg-red-600/20 blur-2xl" />
      <div className="flex items-center gap-2 text-red-400">
        <CalendarStar size={16} weight="bold" />
        <span className="tab-tag text-[11px] tracking-widest uppercase" data-testid={`countdown-${ev.id}-label`}>{ev.label}</span>
      </div>
      <div className="text-[11px] text-slate-400 mt-0.5">{ev.when}</div>
      {isToday ? (
        <div className="font-display text-4xl font-bold text-white mt-4" data-testid={`countdown-${ev.id}-today`}>Today!</div>
      ) : (
        <div className="flex items-end gap-3 sm:gap-5 mt-4">
          <Unit value={Math.floor(s / 86400)} label="Days" testid={`countdown-${ev.id}-days`} />
          <Unit value={Math.floor((s % 86400) / 3600)} label="Hrs" testid={`countdown-${ev.id}-hours`} />
          <Unit value={Math.floor((s % 3600) / 60)} label="Min" testid={`countdown-${ev.id}-minutes`} />
          <Unit value={s % 60} label="Sec" testid={`countdown-${ev.id}-seconds`} />
        </div>
      )}
    </div>
  );
}

export function EventCountdowns() {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);
  // Hide an event once its ET day is over.
  const visible = EVENTS.filter((ev) => etDay(now) <= etDay(new Date(ev.target)));
  if (!visible.length) return null;
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6" data-testid="event-countdowns">
      {visible.map((ev) => <Countdown key={ev.id} ev={ev} now={now} />)}
    </div>
  );
}
